import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import SglContext from "../SglContext";
import ReactModal from "react-modal";
import { Link, useSearchParams } from 'react-router-dom';
import VideoSubscription from "../videos/VideoSubscription";
import play from '../images/play19.png';
import './channels.css'

import JWPlayer from '@jwplayer/jwplayer-react';
import { event } from "jquery";
var AddModal = ReactModal;

function OnDemandDetail(props) { //extends React.Component {
    // state = {
    //     is_user_authorized: false,
    //     channel_subscribed: false,
    //     current_channel: {},
    //     total_rows: 0,
    //     channels_list: [],
    //     stream_link: '',
    //     timeout: null,

    //     videos_list: [],
    //     video_to_play: {},

    //     is_open_do_subscription_modal: false,

    //     loading: true,
    //     userData: {},
    //     login_people_id: -1,
    // };
    const [is_user_authorized, setIs_user_authorized] = useState(false)
    const [channel_subscribed, setChannel_subscribed] = useState(false)
    const [current_channel, setCurrent_channel] = useState({})
    const [total_rows, setTotal_rows] = useState(0)
    const [channels_list, setChannels_list] = useState([])
    const [stream_link, setStream_link] = useState('')
    const [timeout, setTimeout] = useState(null)
    const [play_from_item, setPlay_from_item] = useState(0)
    const [total_videos, setTotal_videos] = useState(0)
    // const [is_mobile, setIs_mobile] = useState(false)

    const [videos_list, setVideos_list] = useState([])
    const [video_to_play, setVideo_to_play] = useState({})

    const [is_open_do_subscription_modal, setIs_open_do_subscription_modal] = useState(false)

    const [loading, setLoading] = useState(true)
    const [userData, setUserData] = useState({})
    const [login_people_id, setLogin_people_id] = useState(-1)
    // const [ip_address, setIp_address] = useState('')
    const Sgl = useContext(SglContext)
    const [searchParam, setSearchParam] = useSearchParams();
    const [VideoSubscriptionElement, seVideoSubscriptionElement] = useState(null);


    const credit_company = process.env.REACT_APP_CREDIT_COMPANY;
    const credit_text = process.env.REACT_APP_CREDIT_TEXT;
    const credit_url = process.env.REACT_APP_CREDIT_URL;


    const configDefaults = { width: '100%', height: '100%',sharing:{sites: ["facebook","twitter","email","interest"]}};

    // constructor(props) {
    //     super(props);

    //     // bind function in constructor instead of render
    //     closeDoSubscriptionModal = closeDoSubscriptionModal.bind(this);
    //     playVideoAfterSubscribe = playVideoAfterSubscribe.bind(this);
    // }


    const sgl_webservice_channels_list = Sgl.nestApiUrl + "/channels";
    const user_info_url = Sgl.nestApiUrl + "/users/getLoggedInUser";
    const sgl_webservice_videos = Sgl.sglApiUrl + '/iphonev2/videosv2/';

    function getBrowserInfo() {
        var sBrowser;
        var sUsrAg = window.navigator.userAgent;

        // The order matters here, and this may report false positives for unlisted browsers.

        if (sUsrAg.indexOf("Firefox") > -1) {
            sBrowser = "Mozilla Firefox";
            // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
        } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
            sBrowser = "Samsung Internet";
            // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
        } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
            sBrowser = "Opera";
            // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
        } else if (sUsrAg.indexOf("Trident") > -1) {
            sBrowser = "Microsoft Internet Explorer";
            // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
        } else if (sUsrAg.indexOf("Edge") > -1) {
            sBrowser = "Microsoft Edge";
            // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
        } else if (sUsrAg.indexOf("Chrome") > -1) {
            sBrowser = "Google Chrome or Chromium";
            // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
        } else if (sUsrAg.indexOf("Safari") > -1) {
            sBrowser = "Apple Safari";
            // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
        } else {
            sBrowser = "unknown";
        }
        return sBrowser;
    }
    // componentDidMount() {
    //     getAllData();

    // }
    useEffect(() => {
        getAllData();
    }, [])

    function getAllData() {
        getUserData();
        getChannelsData();
        checkChannelSubscription();
    }

    function onPlaylistItem(event) {
        var current_video = event.item
        setVideo_to_play(current_video)
        logVideoPlayback(current_video);
        var url = window.location.href;
        var newurl;
        if (url.search('&v_id=') > 0) {
            newurl = url.replace(/&v_id=(.*)/, '&v_id=' + current_video.mediaid);
        } else {
            newurl = url + '&v_id=' + current_video.mediaid;
        }
        // $("#CopyLinkIcon").html(newurl);
        window.history.pushState(current_video.mediaid, '', newurl);
        Sgl.reportToGA('/sgl-wp-plugin/' + Sgl.company_urlpath + '/channels/ondemand/playback/' + searchParam.get('demand_channel') + '/' + current_video.mediaid);
        Sgl.reportToFB('/sgl-wp-plugin/' + Sgl.company_urlpath + '/channels/ondemand/playback/' + searchParam.get('demand_channel') + '/' + current_video.mediaid);

    }
    function getChannelsData() {
        axios
            .get(sgl_webservice_channels_list, {
                params: {
                    channel_type: 'ondemand',
                    customer_id: Sgl.company_id,
                },
            })
            .then((res) => {
                var current_channel = res.data.channels_list.find(el => (el.sgl_id == searchParam.get('demand_channel')));
                Sgl.reportToGA('/sgl-wp-plugin/' + Sgl.company_urlpath + '/channels/ondemand/detail/' + searchParam.get('demand_channel'));
                Sgl.reportToFB('/sgl-wp-plugin/' + Sgl.company_urlpath + '/channels/ondemand/detail/' + searchParam.get('demand_channel'));
                setChannels_list(res.data.channels_list)
                setTotal_rows(res.data.total_records)
                setCurrent_channel(current_channel ? current_channel : {})

            });
    }
    function checkChannelSubscription() {
        axios
            .get(sgl_webservice_channels_list + '/checkSubscription', {
                params: {
                    // channel_type: 'livestream',
                    customer_id: Sgl.company_id,
                },
            })
            .then((res) => {
                setChannel_subscribed(res.data.channel_subscribed)
                setLoading(false)

                if (res.data.channel_subscribed) {
                    getVideoPlaylist();
                } else {
                    openSubscriptionModal();
                }
            });
    }
    function getVideoPlaylist() {
        axios
            .get(sgl_webservice_channels_list + '/playlist', {
                params: {
                    channel_id: searchParam.get('demand_channel'),
                    customer_id: Sgl.company_id,
                    vid: searchParam.get('v_id')
                },
            })
            .then((res) => {
                closeDoSubscriptionModal();
                setChannel_subscribed(res.data.channel_subscribed)
                setPlay_from_item(res.data.play_from_item)
                setVideos_list(res.data.playlist)
                setTotal_videos(res.data.total_videos)
                setVideo_to_play(res.data.playlist && res.data.playlist.length > 0 ? res.data.playlist[0] : {})




                // if(res.data.channel_subscribed){
                //     const self = this;
                //     window.jwplayer("myDetailElement")
                //         .setup({ 
                //             "playlist": res.data.playlist,
                //             // "playlistposition": 'right',
                //             "playlistsize": 140,
                //             // "title": 'abc',
                //             // "autostart": true,
                //             "width": '100%',
                //             "height": '100%',
                //             "displaytitle": true,
                //             "displaydescription": true,
                //             "nextUpDisplay": true,
                //             "repeat": false,
                //             "sharing": {
                //                 sites: ["facebook","twitter","email","pinterest", 'link']
                //             },
                //         })
                //         .onPlaylistItem(function changePlayingVideo(item){
                //             self.setState({video_to_play:item.item})
                //             self.logVideoPlayback(item.item);
                //             var url = window.location.href;
                //             var newurl;
                //             if(url.search('&v_id=') > 0){
                //             newurl = url.replace(/&v_id=(.*)/, '&v_id=' + item.item.mediaid);
                //             }else{
                //             newurl = url + '&v_id=' + item.item.mediaid;
                //             }
                //             // $("#CopyLinkIcon").html(newurl);
                //             window.history.pushState(item.item.mediaid, '', newurl);
                //             Sgl.reportToGA('/sgl-wp-plugin/'+process.env.REACT_APP_COMPANY_PATH+'/channels/ondemand/playback/'+searchParam.get('demand_channel')+'/'+item.item.mediaid);
                //         });
                //     window.jwplayer("myDetailElement").onReady(function(){
                //         window.jwplayer("myDetailElement").playlistItem(res.data.play_from_item);
                //     });
                // }
            });
    }
    function getUserData() {

        axios.get(user_info_url).then(
            (response) => {
                Sgl.checkLoginOnSGL();
                if (response.data.user && response.data.user != null) {
                    setUserData(response.data.user)
                    setLogin_people_id(response.data.user.sgl_id)
                }
            },
            (error) => { }
        );

    }
    function logVideoPlayback(video) {
        var browser = getBrowserInfo();
        axios
            .get(sgl_webservice_videos + 'LogVideoPlayback', {
                params: {
                    channel_id: searchParam.get('demand_channel'),
                    customer_id: Sgl.company_id,
                    vid: video.videos_sgl_id,
                    browser_info: browser,
                    ip_address: Sgl.ip_address,
                    isMobile: Sgl.is_mobile,
                    is_iphone: false,
                    state: 'video played',
                    from_wp_api: true,
                },
            })
            .then(
                (response) => {

                },
                (error) => { }
            );
    }
    //////////// subscription functions /////////
    function openSubscriptionModal() {
        setIs_open_do_subscription_modal(true)
    }
    function closeDoSubscriptionModal() {
        setIs_open_do_subscription_modal(false)
    }
    function playVideoAfterSubscribe() {
        getVideoPlaylist();
        // window.location.href = videos_page_url;
    }
    //////////// end subscription functions /////////

    let inIframe = false;
    if (window.location !== window.parent.location) {
        inIframe = true;
    }

    if (loading) {
        return null;
    }
    return (
        <div className="sgl-plugin section-to-print livestreamcss">
            <h1>{current_channel.name}</h1>
            <h3>{current_channel.description}</h3>
            <div className="credit-text">{credit_text} <a href={credit_url}>{credit_company}</a></div><br />
            <div className='video_player'>
                {(!channel_subscribed) &&
                    <div class='channel_thumbnail'>
                        <a onClick={() => openSubscriptionModal()} className="play-wrapper">
                            <img className='channel_img' src='https://d2m5wh9rea7ao.cloudfront.net/wp_esp/wp-content/uploads/2020/04/23060248/Prize_Money_3-750x421.jpg' />
                            <span className="play-button">
                                <span className="play">
                                    <img src={play} />
                                </span>
                            </span>
                        </a>

                    </div>

                }
                {total_videos > 0 ?
                    <div id="myDetailElement">
                        <JWPlayer
                            config={configDefaults}
                            playlist={videos_list}
                            // library={process.env.PUBLIC_URL + '/jwplayer8.js?v=20230124-1'}
                            library={"https://cdn.jwplayer.com/libraries/hMVctbog.js"}
                            playlistIndex={play_from_item}
                            onPlaylistItem={onPlaylistItem}
                        />
                    </div>
                    :

                    <img className='channel_img' src='https://d2m5wh9rea7ao.cloudfront.net/wp_esp/wp-content/uploads/2020/04/23060248/Prize_Money_3-750x421.jpg' />

                }
            </div>
            <div className='video_stat'>
                <h2 className='link_color'>{current_channel.channel_stats}</h2>
            </div>
            {(channel_subscribed) &&
                <div className="flex-video-container video-data sgl-add_entry">
                    <div className="video_data_container ">
                        <table className="table video-data-table">

                            <tbody>
                                <tr>
                                    <th colspan="1" className="details-table-head">Score:</th>
                                    <td colspan="2">{video_to_play.video_score}</td>
                                </tr>

                                <tr>
                                    <th colspan="1" className="details-table-head">Entry:</th>
                                    <td colspan="2">{video_to_play.title}</td>
                                </tr>

                                <tr>
                                    <th colspan="1" className="details-table-head">Trainer</th>
                                    <td colspan="2">{video_to_play.video_trainer}</td>
                                </tr>

                                <tr>
                                    <th colspan="1" className="details-table-head">Class:</th>
                                    <td colspan="2">{video_to_play.video_class}</td>
                                </tr>

                                {/* {(is_show_entry_videos && getVideoScore(video_to_play)) &&
                                        <tr>
                                        <th colspan="1" className="details-table-head">Score:</th>
                                        <td colspan="2">{getVideoScore(video_to_play)}</td>
                                        </tr>
                                    } */}
                            </tbody>
                        </table>
                    </div>
                    <div className="video_data_container ">
                        <table className="table video-data-table">

                            <tbody>
                                <tr>
                                    <th colspan="1" className="details-table-head">Placing:</th>
                                    <td colspan="2">{video_to_play.video_placing}</td>
                                </tr>

                                <tr>
                                    <th colspan="1" className="details-table-head">Rider:</th>
                                    <td colspan="2">{video_to_play.video_rider}</td>
                                </tr>

                                <tr>
                                    <th colspan="1" className="details-table-head">Owner</th>
                                    <td colspan="2">{video_to_play.video_owner}</td>
                                </tr>

                                <tr>
                                    <th colspan="1" className="details-table-head">Show:</th>
                                    <td colspan="2">{video_to_play.video_show}</td>
                                </tr>

                                <tr>
                                    <th colspan="1" className="details-table-head">Date:</th>
                                    <td colspan="2">{video_to_play.video_date}</td>
                                </tr>


                            </tbody>
                        </table>
                    </div>
                </div>
            }
            <div
                id="videos_listing"
                className="detail_grid"
            >
                <div className="related-videos-header header-bg" >
                    latest Video On Demand
                </div>
                <div className="flex-video-container">

                    {total_rows > 0 ? (
                        channels_list.map((channel, index) => {
                            return (
                                <div className="video_container ">
                                    <div className="video-content">

                                        <div className="thumb-image">
                                            <Link className='cursor-pointer' to={'/demand-channels/detail?demand_channel=' + channel.sgl_id}>
                                                <img src={channel.logo} />
                                                {/* <div className={(channel.status == 'Online')?'green':'red' + ' channel_status'}>{(channel.status == 'Online')?"LIVE":"OFFLINE"}</div> */}
                                            </Link>
                                        </div>
                                        <div className="video_details">

                                            <div>
                                                <Link className='cursor-pointer' to={'/demand-channels/detail?demand_channel=' + channel.sgl_id}>
                                                    <span className="channel_details link_color">
                                                        {channel.name}
                                                    </span>
                                                </Link>
                                            </div>



                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="video_container ">
                            <div className="video-content">
                                <div className="thumb-image">
                                    {/* <img src={horse_logo} /> */}
                                    <span className="float-left">No channels Found</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <AddModal
                isOpen={is_open_do_subscription_modal}
                // onAfterOpen={afterOpenUrlModal}
                onRequestClose={closeDoSubscriptionModal}
                className={"mymodal subscription-modal" + (inIframe ? ' subscription-in-iframe' : '')}
                overlayClassName="myoverlay"
                ariaHideApp={false}
            >
                <VideoSubscription
                    is_download_subscription={false}
                    is_video_subscription={true}
                    subscription_type={'channel'}
                    video_to_play={{ videos_sgl_id: -1 }}
                    closeSubscriptionModal={closeDoSubscriptionModal}
                    playVideoAfterSubscribe={playVideoAfterSubscribe}
                    company_id={Sgl.company_id}
                    ref={VideoSubscriptionElement}
                />
            </AddModal>
            <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
        </div>
    );
    // }
}
export default OnDemandDetail
